// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/matrix/matrix.proto" (package "mlmbox.client.matrix", syntax proto3)
// tslint:disable
import { Matrix_Position } from "../../types/account.ts";
import { Matrix_Reinvest_Request } from "../../types/account.ts";
import { Matrix_View } from "../../types/account.ts";
import { PositionView_Team } from "../../types/account.ts";
import { Matrix_Info } from "../../types/account.ts";
import { Empty } from "../../../google/protobuf/empty.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
/**
 * @generated ServiceType for protobuf service mlmbox.client.matrix.Matrix
 */
export const Matrix = new ServiceType("mlmbox.client.matrix.Matrix", [
    { name: "Info", options: {}, I: Empty, O: Matrix_Info },
    { name: "View", options: {}, I: PositionView_Team, O: Matrix_View },
    { name: "SetReinvestConfig", options: {}, I: Matrix_Reinvest_Request, O: Matrix_Position }
]);
